// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__yIX0U","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__CSULg"};